import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NplexAnswersService } from 'src/app/services/nplex-answers.service';
@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.css'],
})
export class SearchPageComponent {
  public constructor(
    private readonly nplexAnswersService: NplexAnswersService,
    private readonly router: Router
  ) {}

  public displayError: boolean = false;
  public displayNoResults: boolean = false;
  public lastName: string = '';
  public processingRequest: boolean = false;
  public transactionId: string = '';

  public onSubmit(searchForm: NgForm): void {
    // lock the submit button while processing
    this.processingRequest = true;

    // unfortunately I could not find a better way to
    // halt submission through the ngForm directive
    if (!this.transactionId || !this.lastName) {
      this.processingRequest = false;
      return;
    }
    this.nplexAnswersService
      .getNplexAnswersCombined(this.transactionId, this.lastName)
      .subscribe({
        next: (response) => {
          if (response && response.length) {
            this.nplexAnswersService.setNplexAnswersCombinedResults(response);
            this.nplexAnswersService.setTransactionId(this.transactionId);
            this.router.navigate(['/search-results']);
          } else {
            this.displayNoResults = true;
          }
        },
        error: (error) => {
          this.displayError = true;
        },
        complete: () => {
          this.processingRequest = false;
        },
      });
  }

  public onUpdateLastName(lastName: string): void {
    this.lastName = lastName;
  }

  public onUpdateTransactionId(transactionId: string): void {
    this.transactionId = transactionId;
  }
  public toggleDisplayError(): void {
    this.displayError = !this.displayError;
  }

  public toggleDisplayNoResults(): void {
    this.displayNoResults = !this.displayNoResults;
  }
}
